var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF6262"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8335 11.9991L17.0523 6.9703C17.123 6.88673 17.0635 6.75977 16.9542 6.75977H15.6717C15.5962 6.75977 15.5239 6.79352 15.4741 6.85137L11.9946 10.9994L8.51513 6.85137C8.46691 6.79352 8.39459 6.75977 8.31745 6.75977H7.03495C6.92566 6.75977 6.8662 6.88673 6.93691 6.9703L11.1557 11.9991L6.93691 17.0278C6.92107 17.0464 6.91091 17.0692 6.90763 17.0934C6.90436 17.1177 6.9081 17.1423 6.91842 17.1645C6.92874 17.1867 6.94521 17.2054 6.96587 17.2185C6.98652 17.2316 7.0105 17.2385 7.03495 17.2383H8.31745C8.39299 17.2383 8.46531 17.2046 8.51513 17.1467L11.9946 12.9987L15.4741 17.1467C15.5223 17.2046 15.5946 17.2383 15.6717 17.2383H16.9542C17.0635 17.2383 17.123 17.1114 17.0523 17.0278L12.8335 11.9991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.4997d6e7fefa49b6dfdef69727e4a935.svg";
export { ForwardRef as ReactComponent };